import { render, staticRenderFns } from "./ProjectDependencyGraph.vue?vue&type=template&id=b0414764&"
import script from "./ProjectDependencyGraph.vue?vue&type=script&lang=js&"
export * from "./ProjectDependencyGraph.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDependencyGraph.vue?vue&type=style&index=0&id=b0414764&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0414764')) {
      api.createRecord('b0414764', component.options)
    } else {
      api.reload('b0414764', component.options)
    }
    module.hot.accept("./ProjectDependencyGraph.vue?vue&type=template&id=b0414764&", function () {
      api.rerender('b0414764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/projects/ProjectDependencyGraph.vue"
export default component.exports